/**
 * Class that represents the user of the app.
 *
 */
export class UserAuth {

    /**
     * Construct a new User object.
     *
     * @param _name
     *   User name.
     */
    constructor(
        protected _name: string,
    ) {
    }

    get name(): string {
        return this._name;
    }
}
